// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompanySectionTwo {
  width: 100%;
  min-height: 400px;
  background-image: linear-gradient(#ffffff 50%, #dfe3fa 50%);
  color: #000000;
  display: flex;
  flex-direction: column;
  position: relative;
  font-size: 18px;
  padding: 160px 130px 200px;
}
.CompanySectionTwo .description-text {
  font-size: 18px;
  line-height: 33px;
  text-align: center;
  padding: 10px 100px;
}
.CompanySectionTwo .CompanySectionTwo-team-div {
  position: relative;
  margin-top: 100px;
  margin-bottom: -200px;
  z-index: 1;
}
.CompanySectionTwo .CompanySectionTwo-team-div h2 {
  font-size: 38px;
  color: #ec7c45;
  margin-bottom: 30px;
  font-family: roboto;
  font-weight: 400;
}
.CompanySectionTwo .CompanySectionTwo-team-div .CompanySectionTwo-team-list {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.CompanySectionTwo .CompanySectionTwo-team-div .CompanySectionTwo-team-list .ui.card {
  margin: 0 !important;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  border-radius: 10px;
  padding: 15px;
  width: 24%;
}
.CompanySectionTwo .CompanySectionTwo-team-div .CompanySectionTwo-team-list .ui.card .content {
  padding: 10px 0px;
}
.CompanySectionTwo .CompanySectionTwo-team-div .CompanySectionTwo-team-list .ui.card .content .description {
  font-size: 18px;
  color: #000;
  line-height: 23px;
  margin-top: 0.7rem;
}
.CompanySectionTwo .CompanySectionTwo-team-div .CompanySectionTwo-team-list .ui.card .content .header:not(.ui) {
  line-height: 1.33em;
  font-size: 24px;
  font-weight: 700;
  color: #1d1d37;
  margin-top: 15px;
}
.CompanySectionTwo .CompanySectionTwo-team-div .CompanySectionTwo-team-list .ui.card .content .meta {
  font-size: 18px;
  font-weight: 500;
  color: #1d1d37;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid rgba(157, 170, 241, 0.32);
}
.CompanySectionTwo .CompanySectionTwo-team-div .CompanySectionTwo-team-list .ui.card .extra {
  border-top: none !important;
}
.CompanySectionTwo .CompanySectionTwo-team-div .CompanySectionTwo-team-list .CompanySectionTwo-team-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: #ffffff;
  width: 23%;
  min-height: 300px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  border-radius: 10px;
  padding: 15px;
}
.CompanySectionTwo .CompanySectionTwo-team-div .CompanySectionTwo-team-list .CompanySectionTwo-team-card img {
  width: 100%;
}
.CompanySectionTwo .CompanySectionTwo-team-div .CompanySectionTwo-team-list .CompanySectionTwo-team-card .name {
  font-size: 28px;
  font-weight: 700;
  color: #1d1d37;
}
.CompanySectionTwo .CompanySectionTwo-team-div .CompanySectionTwo-team-list .CompanySectionTwo-team-card .title {
  font-size: 15px;
  font-weight: 500;
  color: #1d1d37;
}
.CompanySectionTwo .CompanySectionTwo-team-div .CompanySectionTwo-team-list .CompanySectionTwo-team-card .description {
  font-size: 14px;
  color: #7a7a7a;
  line-height: 23px;
  min-height: 180px;
}
.CompanySectionTwo .CompanySectionTwo-voilet-bg-wrapper {
  display: block;
  width: 100%;
  position: relative;
  z-index: 0;
  margin-top: -200px;
}
.CompanySectionTwo .CompanySectionTwo-voilet-bg {
  position: absolute;
  background-color: #1C2640;
  height: 900px;
  margin-left: -130px;
  margin-right: -130px;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}
.CompanySectionTwo .CompanySectionTwo-advisor-div {
  position: relative;
  z-index: 1;
  margin-top: 500px;
}
.CompanySectionTwo .CompanySectionTwo-advisor-div h2 {
  font-size: 38px;
  color: #fff;
  margin-bottom: 40px;
  font-family: roboto;
  font-weight: 400;
}
.CompanySectionTwo .CompanySectionTwo-advisor-div .CompanySectionTwo-advisor-list {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.CompanySectionTwo .CompanySectionTwo-advisor-div .CompanySectionTwo-advisor-list .ui.card {
  margin: 0 !important;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  border-radius: 10px;
  padding: 15px;
  width: 24%;
}
.CompanySectionTwo .CompanySectionTwo-advisor-div .CompanySectionTwo-advisor-list .ui.card .content {
  padding: 10px 0px;
}
.CompanySectionTwo .CompanySectionTwo-advisor-div .CompanySectionTwo-advisor-list .ui.card .content .description {
  font-size: 18px;
  color: #000;
  line-height: 23px;
  margin-top: 0.7rem;
}
.CompanySectionTwo .CompanySectionTwo-advisor-div .CompanySectionTwo-advisor-list .ui.card .content .header:not(.ui) {
  line-height: 1.33em;
  font-size: 24px;
  font-weight: 700;
  color: #1d1d37;
  margin-top: 15px;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid rgba(157, 170, 241, 0.32);
  text-transform: uppercase;
}
.CompanySectionTwo .CompanySectionTwo-advisor-div .CompanySectionTwo-advisor-list .ui.card .extra {
  border-top: none !important;
}
.CompanySectionTwo .CompanySectionTwo-advisor-div .CompanySectionTwo-advisor-list .CompanySectionTwo-advisor-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: #ffffff;
  width: 23%;
  min-height: 300px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  border-radius: 10px;
  padding: 15px;
}
.CompanySectionTwo .CompanySectionTwo-advisor-div .CompanySectionTwo-advisor-list .CompanySectionTwo-advisor-card img {
  width: 100%;
}
.CompanySectionTwo .CompanySectionTwo-advisor-div .CompanySectionTwo-advisor-list .CompanySectionTwo-advisor-card .name {
  font-size: 28px;
  font-weight: 700;
  color: #1d1d37;
}
.CompanySectionTwo .CompanySectionTwo-advisor-div .CompanySectionTwo-advisor-list .CompanySectionTwo-advisor-card .title {
  font-size: 15px;
  font-weight: 500;
  color: #1d1d37;
}
.CompanySectionTwo .CompanySectionTwo-advisor-div .CompanySectionTwo-advisor-list .CompanySectionTwo-advisor-card .description {
  font-size: 14px;
  color: #7a7a7a;
  line-height: 23px;
  min-height: 180px;
}

.modal-company {
  margin-top: -12.5% !important;
  width: 65% !important;
}
.modal-company .content .close-btn {
  float: right;
}
.modal-company .content .close-btn:hover {
  cursor: pointer;
}
.modal-company .content .content-profil {
  display: flex;
}
.modal-company .content .content-profil .profil {
  width: 50%;
}
.modal-company .content .content-profil .profil .img-profil {
  width: 400px;
  height: 400px;
}
.modal-company .content .content-profil .profil-description {
  width: 60%;
  padding: 0px;
  margin-left: 10px;
}
.modal-company .content .content-profil .profil-description .header {
  font-size: 30px;
  text-transform: uppercase;
  font-family: "Roboto";
  font-weight: 500;
  color: #EC6927;
}
.modal-company .content .content-profil .profil-description .sub-header {
  margin-top: 5px;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 500;
  font-family: "Roboto";
}
.modal-company .content .content-profil .profil-description .description {
  line-height: 25px;
  color: #1C2640;
  font-weight: 400;
  font-size: 16px;
  text-align: justify;
}
.modal-company .content .content-profil .profil-description .linkedin .ui.linkedin.icon {
  position: absolute;
  bottom: 30px;
}`, "",{"version":3,"sources":["webpack://./src/components/Company/SectionTwo/SectionTwo.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,iBAAA;EACA,2DAAA;EAKA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;AAHD;AAKC;EACC,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAHF;AAMC;EACC,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,UAAA;AAJF;AAME;EACC,eAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACG,gBAAA;AAJN;AAOE;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;AALH;AAMG;EACI,oBAAA;EACA,4EAAA;EAEA,mBAAA;EACA,aAAA;EACA,UAAA;AALP;AAMO;EACC,iBAAA;AAJR;AAKQ;EACC,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAHT;AAKQ;EACC,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAHT;AAKQ;EACC,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,kDAAA;AAHT;AAiBO;EACC,2BAAA;AAfR;AAkBG;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,4EAAA;EAEA,mBAAA;EACA,aAAA;AAjBJ;AAmBI;EACC,WAAA;AAjBL;AAoBI;EACC,eAAA;EACA,gBAAA;EACA,cAAA;AAlBL;AAqBI;EACC,eAAA;EACA,gBAAA;EACA,cAAA;AAnBL;AAsBI;EACC,eAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AApBL;AA0BC;EACC,cAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AAxBF;AA2BC;EACC,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AAzBF;AA4BC;EACC,kBAAA;EACA,UAAA;EACA,iBAAA;AA1BF;AA2BE;EACC,eAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACG,gBAAA;AAzBN;AA4BE;EACC,aAAA;EACA,mBAAA;EACA,6BAAA;AA1BH;AA2BG;EACI,oBAAA;EACA,4EAAA;EAEA,mBAAA;EACA,aAAA;EACA,UAAA;AA1BP;AA2BO;EACC,iBAAA;AAzBR;AA0BQ;EACC,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAxBT;AA0BQ;EACC,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,kDAAA;EACA,yBAAA;AAxBT;AA4BO;EACC,2BAAA;AA1BR;AA6BG;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,4EAAA;EAEA,mBAAA;EACA,aAAA;AA5BJ;AA8BI;EACC,WAAA;AA5BL;AA+BI;EACC,eAAA;EACA,gBAAA;EACA,cAAA;AA7BL;AAgCI;EACC,eAAA;EACA,gBAAA;EACA,cAAA;AA9BL;AAiCI;EACC,eAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AA/BL;;AAuHA;EACI,6BAAA;EACA,qBAAA;AApHJ;AAsHK;EACC,YAAA;AApHN;AAqHM;EACC,eAAA;AAnHP;AAsHK;EACC,aAAA;AApHN;AAsHM;EACC,UAAA;AApHP;AAqHO;EACC,YAAA;EACA,aAAA;AAnHR;AAsHM;EACC,UAAA;EACA,YAAA;EACA,iBAAA;AApHP;AAqHO;EACC,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;AAnHR;AAqHI;EACI,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAnHR;AAsHI;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AApHR;AAwHS;EACC,kBAAA;EACA,YAAA;AAtHV","sourcesContent":[".CompanySectionTwo {\n\twidth: 100%;\n\tmin-height: 400px;\n\tbackground-image: linear-gradient(\n\t\t// 90deg,\n\t\t#ffffff 50%,\n\t\t#dfe3fa 50%\n\t);\n\tcolor: #000000;\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n\tfont-size: 18px;\n\tpadding: 160px 130px 200px;\n\n\t.description-text {\n\t\tfont-size: 18px;\n\t\tline-height: 33px;\n\t\ttext-align: center;\n\t\tpadding: 10px 100px;\n\t}\n\n\t.CompanySectionTwo-team-div {\n\t\tposition: relative;\n\t\tmargin-top: 100px;\n\t\tmargin-bottom: -200px;\n\t\tz-index: 1;\n\n\t\th2 {\n\t\t\tfont-size: 38px;\n\t\t\tcolor: #ec7c45;\n\t\t\tmargin-bottom: 30px;\n\t\t\tfont-family: roboto;\n    \t\tfont-weight: 400;\n\t\t}\n\n\t\t.CompanySectionTwo-team-list {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\tjustify-content: space-between;\n\t\t\t.ui.card {\n\t\t\t    margin: 0 !important;\n\t\t\t    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px,\n\t\t\t\t\trgba(0, 0, 0, 0.23) 0px 3px 6px;\n    \t\t\tborder-radius: 10px;\n    \t\t\tpadding: 15px;\n    \t\t\twidth: 24%;\n    \t\t\t.content{\n    \t\t\t\tpadding: 10px 0px;\n    \t\t\t\t.description{\n    \t\t\t\t\tfont-size: 18px;\n\t    \t\t\t\tcolor: #000;\n\t   \t\t\t\t\tline-height: 23px;\n\t   \t\t\t\t\tmargin-top: 0.7rem;\n    \t\t\t\t}\n    \t\t\t\t.header:not(.ui){\n    \t\t\t\t\tline-height: 1.33em;\n\t\t    \t\t\tfont-size: 24px;\n\t\t   \t\t\t\tfont-weight: 700;\n\t\t    \t\t\tcolor: #1d1d37;\n\t\t   \t\t\t\tmargin-top: 15px;\n    \t\t\t\t}\n    \t\t\t\t.meta{\n    \t\t\t\t\tfont-size: 18px;\n    \t\t\t\t\tfont-weight: 500;\n    \t\t\t\t\tcolor: #1d1d37;\n    \t\t\t\t\tpadding-bottom: 0.5rem;\n    \t\t\t\t\tborder-bottom: 2px solid rgba(157, 170, 241, 0.32);\n    \t\t\t\t}\n    \t\t\t\t// .button {\n\t\t      //       \tpadding: 5px 20px;\n\t\t      //           font-size: 14px;\n\t\t      //           font-weight: 500;\n\t\t      //           margin-top: 40px;\n\t\t      //           color: #1C2640;\n\t\t      //           border: none;\n\t\t      //           border-radius: 3px;\n\t\t      //       }\n\n    \t\t\t}\n\n    \t\t\t.extra{\n    \t\t\t\tborder-top: none !important;\n    \t\t\t}\n\t\t\t}\n\t\t\t.CompanySectionTwo-team-card {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tbackground-color: #ffffff;\n\t\t\t\twidth: 23%;\n\t\t\t\tmin-height: 300px;\n\t\t\t\tbox-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px,\n\t\t\t\t\trgba(0, 0, 0, 0.23) 0px 3px 6px;\n\t\t\t\tborder-radius: 10px;\n\t\t\t\tpadding: 15px;\n\n\t\t\t\timg {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\n\t\t\t\t.name {\n\t\t\t\t\tfont-size: 28px;\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tcolor: #1d1d37;\n\t\t\t\t}\n\n\t\t\t\t.title {\n\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tcolor: #1d1d37;\n\t\t\t\t}\n\n\t\t\t\t.description {\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tcolor: #7a7a7a;\n\t\t\t\t\tline-height: 23px;\n\t\t\t\t\tmin-height: 180px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.CompanySectionTwo-voilet-bg-wrapper {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\tposition: relative;\n\t\tz-index: 0;\n\t\tmargin-top: -200px;\n\t}\n\n\t.CompanySectionTwo-voilet-bg {\n\t\tposition: absolute;\n\t\tbackground-color: #1C2640;\n\t\theight: 900px;\n\t\tmargin-left: -130px;\n\t\tmargin-right: -130px;\n\t\ttop: 50px;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tz-index: 1;\n\t}\n\n\t.CompanySectionTwo-advisor-div {\n\t\tposition: relative;\n\t\tz-index: 1;\n\t\tmargin-top: 500px;\n\t\th2 {\n\t\t\tfont-size: 38px;\n\t\t\tcolor: #fff;\n\t\t\tmargin-bottom: 40px;\n\t\t\tfont-family: roboto;\n    \t\tfont-weight: 400;\n\t\t}\n\n\t\t.CompanySectionTwo-advisor-list {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\tjustify-content: space-evenly;\n\t\t\t.ui.card {\n\t\t\t    margin: 0 !important;\n\t\t\t    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px,\n\t\t\t\t\trgba(0, 0, 0, 0.23) 0px 3px 6px;\n    \t\t\tborder-radius: 10px;\n    \t\t\tpadding: 15px;\n    \t\t\twidth: 24%;\n    \t\t\t.content{\n    \t\t\t\tpadding: 10px 0px;\n    \t\t\t\t.description{\n    \t\t\t\t\tfont-size: 18px;\n\t    \t\t\t\tcolor: #000;\n\t   \t\t\t\t\tline-height: 23px;\n\t   \t\t\t\t\tmargin-top: 0.7rem;\n    \t\t\t\t}\n    \t\t\t\t.header:not(.ui){\n    \t\t\t\t\tline-height: 1.33em;\n\t\t    \t\t\tfont-size: 24px;\n\t\t   \t\t\t\tfont-weight: 700;\n\t\t    \t\t\tcolor: #1d1d37;\n\t\t   \t\t\t\tmargin-top: 15px;\n\t\t   \t\t\t\tpadding-bottom: 0.5rem;\n    \t\t\t\t\tborder-bottom: 2px solid rgba(157, 170, 241, 0.32);\n    \t\t\t\t\ttext-transform: uppercase;\n    \t\t\t\t}\n    \t\t\t}\n\n    \t\t\t.extra{\n    \t\t\t\tborder-top: none !important;\n    \t\t\t}\n\t\t\t}\n\t\t\t.CompanySectionTwo-advisor-card {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tbackground-color: #ffffff;\n\t\t\t\twidth: 23%;\n\t\t\t\tmin-height: 300px;\n\t\t\t\tbox-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px,\n\t\t\t\t\trgba(0, 0, 0, 0.23) 0px 3px 6px;\n\t\t\t\tborder-radius: 10px;\n\t\t\t\tpadding: 15px;\n\n\t\t\t\timg {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\n\t\t\t\t.name {\n\t\t\t\t\tfont-size: 28px;\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tcolor: #1d1d37;\n\t\t\t\t}\n\n\t\t\t\t.title {\n\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tcolor: #1d1d37;\n\t\t\t\t}\n\n\t\t\t\t.description {\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tcolor: #7a7a7a;\n\t\t\t\t\tline-height: 23px;\n\t\t\t\t\tmin-height: 180px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\n\n\t// .CompanySectionTwo-partners-div {\n\t// \tposition: relative;\n\t// \tz-index: 1;\n\t// \tmargin-top: 600px;\n\n\t// \th2 {\n\t// \t\tfont-size: 38px;\n\t// \t\tfont-weight: 500;\n\t// \t\tcolor: #ffffff;\n\t// \t}\n\n\t// \timg {\n\t// \t\twidth: 50px;\n\t// \t    height: auto;\n\t// \t    margin-left: -5px;\n\t// \t    margin-bottom: 5px;\n\t// \t}\n\n\t// \t#CompanySectionTwo-card{\n\t//         height: 425px;\n\t//         grid-gap: 5%;\n\t//         gap: 4%;\n\t//         background-color: white;\n\t//         border-radius: 10px;\n\t//         margin-top: 5%;\n\t//         display: flex;\n\t//         flex-direction: row;\n\t//         align-items: center;\n\t//         justify-content: center;\n\t//     }\n\n\t//     #CompanySectionTwo-card-1{\n\t//         width: 28%;\n\t//         height: 300px;\n\t//         border-right: 2px solid rgba(51, 51, 51, 0.5);\n\t//     }\n\t//     #CompanySectionTwo-card-2{\n\t//         width: 30%;\n\t//         height: 300px;\n\t//         border-right: 2px solid rgba(51, 51, 51, 0.5);\n\t//     }\n\t//     #CompanySectionTwo-card-3{\n\t//         width: 26%;\n\t//         height: 300px;\n\t//     }\n\n\t//     #CompanySectionTwo-card-1-icon,#CompanySectionTwo-card-2-icon,#CompanySectionTwo-card-3-icon {\n\t//         width: 20%;\n\t//     }\n\n\t//     #CompanySectionTwo-card-1-head1,#CompanySectionTwo-card-2-head1,#CompanySectionTwo-card-3-head1{\n\t//         color: #6A6A6A;\n\t//         font-style: normal;\n\t//         font-weight: 500;\n\t//         font-size: 18px;\n\t//         line-height: 20px;\n\t//         margin-top: 4%;\n\t//     }\n\n\t//     #CompanySectionTwo-card-1-head2,#CompanySectionTwo-card-2-head2,#CompanySectionTwo-card-3-head2{\n\t//         font-style: normal;\n\t//         font-weight: bold !important;\n\t//         font-size: 21px;\n\t//         line-height: 20px;  \n\t//         color: #cf6930 !important;\n\t//         margin-top: 2%;\n\t//     }\n\n\t//     #CompanySectionTwo-card-1-para,#CompanySectionTwo-card-2-para,#CompanySectionTwo-card-3-para{\n\t//         font-style: normal;\n\t//         font-weight: normal;\n\t//         font-size: 15px;\n\t//         line-height: 1.5 !important;\n\t//         margin-top: 7%;\n\t//         margin-right: 10%;\n\t//         color: #1C2640;\n\t//     }\n\t// }\n}\n\n.modal-company {\n    margin-top: -12.5% !important;\n    width: 65% !important;\n    .content{\n    \t.close-btn{\n    \t\tfloat: right;\n    \t\t&:hover{\n    \t\t\tcursor: pointer;\n    \t\t} \n    \t}\n    \t.content-profil {\n\t\t    display: flex;\n\n\t\t    .profil{\n\t\t    \twidth: 50%;\n\t\t    \t.img-profil {\n    \t\t\t\twidth: 400px;\n    \t\t\t\theight: 400px;\n\t\t\t\t}\n\t\t    }\n\t\t    .profil-description{\n\t\t    \twidth: 60%;\n\t\t    \tpadding: 0px;\n\t\t    \tmargin-left: 10px;\n\t\t    \t.header {\n    \t\t\t\tfont-size: 30px;\n    \t\t\t\ttext-transform: uppercase;\n    \t\t\t\tfont-family: 'Roboto';\n    \t\t\t\tfont-weight: 500;\n   \t\t\t\t\tcolor: #EC6927;\n\t\t\t\t}\n\t\t\t\t.sub-header {\n    \t\t\t\tmargin-top: 5px;\n    \t\t\t\tmargin-bottom: 10px;\n    \t\t\t\tfont-size: 18px;\n    \t\t\t\tfont-weight: 500;\n    \t\t\t\tfont-family: 'Roboto';\n\t\t\t\t}\n\n\t\t\t\t.description {\n    \t\t\t\tline-height: 25px;\n    \t\t\t\tcolor: #1C2640;\n    \t\t\t\tfont-weight: 400;\n    \t\t\t\tfont-size: 16px;\n    \t\t\t\ttext-align: justify;\n    \t\t\t\t\n\t\t\t\t}\n\t\t\t\t.linkedin{\n    \t\t\t\t\t.ui.linkedin.icon{\n    \t\t\t\t\t\tposition: absolute;\n    \t\t\t\t\t\tbottom: 30px;\n    \t\t\t\t\t}\n    \t\t\t\t}\n\t\t    }\n\t\t}\n\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
